import { GenericId } from "convex/values"
import Card from "@mui/material/Card"
import Typography from "@mui/material/Typography"
import CardMedia from "@mui/material/CardMedia"
import CardActions from "@mui/material/CardActions"
import Delete from "@mui/icons-material/Delete"
import IconButton from "@mui/material/IconButton"
import CardActionArea from "@mui/material/CardActionArea"
import Tooltip from "@mui/material/Tooltip"
import { Link } from "react-router-dom"

type Props = {
  drawingId: GenericId<"drawings">
  name: string
  previewUrl: string | null
  onDelete: (drawingId: GenericId<"drawings">) => void
}

export function DrawingCard({ drawingId, name, previewUrl, onDelete }: Props) {
  function handleDelete(ev: React.MouseEvent) {
    ev.preventDefault()
    ev.stopPropagation()
    onDelete(drawingId)
  }
  return (
    <Card
      style={{
        position: "relative",
        height: 200,
      }}
    >
      <CardActionArea
        component={Link}
        to={`/drawing/${drawingId}`}
        style={{ height: 200 }}
      >
        <CardMedia
          component="img"
          alt={name}
          image={
            previewUrl ??
            "https://ionicframework.com/docs/img/demos/card-media.png"
          }
          style={{ position: "absolute", width: "100%", height: "100%" }}
        />
        <CardActions
          style={{
            position: "absolute",
            display: "flex",
            bottom: 0,
            background: "rgba(255, 255, 255, 0.8)",
            width: "100%",
          }}
        >
          <Typography variant="subtitle1" style={{ flex: 1, paddingLeft: 8 }}>
            {name}
          </Typography>
          <IconButton onClick={handleDelete}>
            <Tooltip title="Delete Drawing">
              <Delete />
            </Tooltip>
          </IconButton>
        </CardActions>
      </CardActionArea>
    </Card>
  )
}
